import useGetCurrentsTools from "./useGetCurrentsTools.js";
import useGetValueFromArray from "./useGetValueFromArray.js";

const useGetDataFromPathId = () => {

  const getCurrentsTools = useGetCurrentsTools();
  const getValueFromArray = useGetValueFromArray();

  const getDataFromPathId = (updatedToolData, value) => {
    
    if (isRelationShipProperty(value)) {
      return getValueFromArray(value, updatedToolData, undefined, true).value
      //return getValue(updatedToolData, value.slice(-1))
    }
    else
      return value
  };

  const isRelationShipProperty = (value) => {
    return Array.isArray(value)
  };

  const getValue = (updatedToolData, id) => {
    var currentTools = []
    getCurrentsTools( updatedToolData, currentTools, id)
    return currentTools[0]["properties"]["text"].value
  }

  return getDataFromPathId;
};

export default useGetDataFromPathId;
